<ion-header>
  <ion-toolbar style="padding: 0 5px">
    <div class="flex-space-between">
      <h1
        style="
          margin-left: 14px;
          margin-top: 11px;
          margin-bottom: 14px;
          font-size: 0.9rem;
        "
      >
        Apps & Integrations
      </h1>
      <ion-button
        fill="clear"
        color="dark"
        (click)="toggleInstalledFilter()"
        class="btn-sm margin-left-10"
      >
        <ion-icon
          [name]="showInstalledOnly ? 'checkbox' : 'square-outline'"
          class="padded-icon"
        ></ion-icon>
        Show my installed apps
      </ion-button>
    </div>
    <div style="padding: 5px 0 13px 0px" class="hidden-sm">
      <span
        *ngFor="let cat of categories"
        class="tab-nav-link"
        [ngClass]="{ 'tab-nav-active': category === cat }"
        (click)="selectCategory(cat)"
      >
        {{ categoryNames[cat] ?? cat }}
      </span>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid class="constrained-content">
    <ion-row>
      <ion-col size-md="4" size="12" *ngFor="let app of apps">
        <ion-card class="outline-card">
          <img class="plan-card-image" [src]="app.imageSrc" />
          <ion-card-header style="padding: 20px">
            <ion-card-title>
              {{ app.name }}
              <ion-badge
                color="warning"
                *ngIf="app.isBeta"
                style="font-size: 0.5rem"
                >BETA</ion-badge
              >
            </ion-card-title>
            <ion-card-subtitle style="line-height: 1.5; min-height: 66px">
              <div [innerHTML]="app.preview"></div>
            </ion-card-subtitle>
          </ion-card-header>
          <ion-card-content
            [hidden]="
              (app.type === 'external-crm' && !crmFeatureEnabled) ||
              (app.type === 'external-task-management' && !taskFeatureEnabled)
            "
          >
            <div class="flex-space-between">
              <ion-button
                [color]="
                  app.installable &&
                  authService.tenant.integrations[app.key]?.enabled
                    ? 'success'
                    : 'primary'
                "
                [fill]="
                  app.installable &&
                  authService.tenant.integrations[app.key]?.enabled
                    ? 'solid'
                    : 'outline'
                "
                *ngIf="!app.url"
                (click)="requestAccess(app)"
              >
                <ion-icon
                  name="checkmark-outline"
                  *ngIf="
                    app.installable &&
                    authService.tenant.integrations[app.key]?.enabled
                  "
                ></ion-icon>
                {{
                  app.installable
                    ? authService.tenant.integrations[app.key]?.enabled
                      ? "Installed"
                      : "Configure"
                    : "Request access"
                }}
              </ion-button>
              <ion-button *ngIf="app.url" (click)="viewIntegration(app)">
                View
              </ion-button>
              <div
                class="app-options"
                *ngIf="
                  app.installable &&
                  authService.tenant.integrations[app.key]?.enabled
                "
              >
                <ion-button
                  fill="clear"
                  color="primary"
                  (click)="openIntegrationOptions(app, $event)"
                  title="Integration options"
                >
                  <ion-icon name="ellipsis-vertical"></ion-icon>
                </ion-button>
              </div>
            </div>
          </ion-card-content>
          <ion-card-content
            *ngIf="
              (app.type === 'external-crm' && !crmFeatureEnabled) ||
              (app.type === 'external-task-management' && !taskFeatureEnabled)
            "
          >
            <ion-button
              color="success"
              (click)="upgradeAccount()"
              ngxTippy
              data-tippy-content="This integration requires upgrading your subscription"
            >
              <ion-icon name="arrow-up-circle" class="padded-icon"></ion-icon>
              Upgrade to install
            </ion-button>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
